import { SpamNumberModel, SpamNumberFormState, DefaultServiceResult } from '@/types';
import BaseService from '@/services/api/BaseService';

class SpamNumberService extends BaseService<SpamNumberModel | SpamNumberFormState> {
    activate<ResponseT = DefaultServiceResult>(id: number | string) {
        return this.http.put<ResponseT>(`${this.route}/${id}/activate`);
    }
    inactivate<ResponseT = DefaultServiceResult>(id: number | string) {
        return this.http.put<ResponseT>(`${this.route}/${id}/inactivate`);
    }
}

export default new SpamNumberService('spam-numbers');
